import { ActorRoles, Link } from '.'
import {
  EVENT_HUB_LINK,
  HOST_LEADS_LINK,
  HOST_READYMAG_LINK,
  HOST_ADMIN_LINK,
  HOST_SPACES_LINK,
  BRIEF_BUILDER_LINK,
  LOGIN_LINK,
  SMART_BOOK_RESPONSE_LINK,
  SMART_BOOK_EVENTS_LINK,
  HOST_HOME_LINK
} from '../Constants'

import { useGlobalState } from '../Store'
import { affixNotifications, useNotifications } from '../Hooks/useNotifications'

export const eventHub: Link = {
  href: EVENT_HUB_LINK,
  icon: 'EventHub',
  target: '_blank',
  title: 'Event hub'
}

export const leadFeed: Link = {
  href: `${HOST_LEADS_LINK}/leadfeed`,
  icon: 'LeadFeed',
  title: 'Lead Feed'
}

export const listWithUs: Link = {
  href: HOST_READYMAG_LINK,
  icon: 'MyVenues',
  title: 'List with us'
}

export const hostAdmin: Link = {
  href: `${HOST_ADMIN_LINK}/lf-leads`,
  icon: 'Admin',
  title: 'Admin'
}

export const hostVenues: Link = {
  href: HOST_SPACES_LINK,
  icon: 'MyVenues',
  title: 'Your venues'
}

export const planYourEvent: Link = {
  href: BRIEF_BUILDER_LINK,
  icon: 'PlanMyEvent',
  title: 'Plan your event'
}

export const signIn: Link = {
  href: `${LOGIN_LINK}?redirect_to=${window.location.href}`,
  icon: 'SignIn',
  title: 'Sign in'
}

export const smartBookResponse: Link = {
  href: `${SMART_BOOK_RESPONSE_LINK}/opportunities`,
  icon: 'SmartBook',
  title: 'Smart Book'
}

export const smartBookEvents: Link = {
  href: SMART_BOOK_EVENTS_LINK,
  icon: 'SmartBook',
  title: 'Smart Book'
}

export const hostHome: Link = {
  href: HOST_HOME_LINK,
  icon: 'HostHome',
  title: 'Home'
}

const bizLegacyTopNav: Link[] = [planYourEvent, eventHub]
const bizTopNav: Link[] = [planYourEvent, smartBookEvents]
const supportTopNav: Link[] = [hostAdmin, planYourEvent, hostHome, leadFeed, eventHub, hostVenues]

const topNav: Record<ActorRoles, Link[]> = {
  [ActorRoles.UNKNOWN]: [listWithUs, planYourEvent, signIn],
  [ActorRoles.B2C_GUEST]: [planYourEvent],
  [ActorRoles.LEAD_FEED_HOST]: [hostHome, leadFeed, hostVenues],
  [ActorRoles.SMART_BOOK_HOST]: [hostHome, leadFeed, smartBookResponse, hostVenues],
  [ActorRoles.BIZ_MEMBER_LEGACY]: bizLegacyTopNav,
  [ActorRoles.BIZ_MANAGER_LEGACY]: bizLegacyTopNav,
  [ActorRoles.BIZ_ADMIN_LEGACY]: bizLegacyTopNav,
  [ActorRoles.BIZ_MANAGER]: bizTopNav,
  [ActorRoles.BIZ_MEMBER]: bizTopNav,
  [ActorRoles.BIZ_ADMIN]: bizTopNav,
  [ActorRoles.ACCOUNT_MANAGER]: supportTopNav,
  [ActorRoles.REGIONAL_MANAGER]: supportTopNav,
  [ActorRoles.ADMIN]: supportTopNav
}

export const useTopNav = (): Link[] => {
  const [{ role, user }] = useGlobalState('session')
  const [withoutNav] = useGlobalState('withoutNav')
  const notifications = useNotifications(user, role)
  const navOptionsByRole = topNav[role]

  if (role === undefined || withoutNav) {
    return null
  }

  const updatedNav = affixNotifications(role, navOptionsByRole, notifications)

  return updatedNav
}
